module.exports = __webpack_public_path__ + "static/media/find-user.528789e6.svg";